import type { VotePercentage } from "@/services";
import { isFinite } from "lodash-es";

// number transformation
const toBigInt = (number: number) => {
    return BigInt(Math.floor(Number((number * 100).toFixed(2))));
};

const fromBigInt = (number: bigint) => {
    return Number((Number(number) / 100).toFixed(2));
};

/**
 * Normalizes an array of numbers to sum to 100 while maintaining their relative proportions and respecting limits
 */
export const normalizeTo100 = (numbers: number[], excludeIndex: number): number[] => {
    const total = numbers.reduce((acc, curr) => acc + curr, 0);
    const totalWithoutExcluded = Number(total) - Number(numbers[excludeIndex]);
    const expectedSum = 100 - numbers[excludeIndex];

    if (total < 50) {
        return Array(numbers.length).fill(0);
    }

    const scaledNumbers = numbers.map((x, index) => {
        if (index === excludeIndex) {
            return x;
        }

        if (totalWithoutExcluded === 0) {
            return 0;
        }

        return Number(((x * expectedSum) / totalWithoutExcluded).toFixed(0));
    });

    const transformedNumbers = scaledNumbers.map((x) => (isFinite(x) ? toBigInt(x) : 0n));
    const transformedTotal = transformedNumbers.reduce((acc, curr) => acc + curr, 0n);

    transformedNumbers[excludeIndex] -= transformedTotal - 10000n;

    return transformedNumbers.map(fromBigInt);
};

export const convertVotesToPercentages = (votes: VotePercentage[]): number[] => {
    return votes.map((vote) => vote.percentage);
};

export function calculatePercentage(x: number, percentage: number) {
    return (x * percentage) / 100;
}
